import * as u from './utils';

export default () => {
    const container = document.querySelectorAll('.international-sites');

    for (const el of container) {
        const trigger = el.querySelector('.international-sites__trigger');
        const sites = el.querySelector('.international-sites__sites');

        trigger.addEventListener('click', () => {
            u.toggleClass(sites, 'is-active');
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.international-sites')) {
                u.removeClass(sites, 'is-active');
            }
        });
    }
};
